{
  "archived": "مؤرشف",
  "fieldServiceTag": "خدمة ميدانية",
  "actions": {
    "new": "فريق جديد",
    "board": "فتح اللوحة",
    "newTask": "مهمة جديدة",
    "archive": "أرشفة",
    "restore": "استعادة"
  },
  "fields": {
    "name": "الاسم",
    "nameAr": "الاسم بالعربية",
    "description": "الوصف",
    "allowSelfClaim": "يستطيع الأعضاء أخذ المهام من قائمة الفريق",
    "fieldService": "يقوم بزيارات الخدمة",
    "members": "الأعضاء",
    "leads": "القادة",
    "memberCount": "الأعضاء",
    "myRole": "دورك"
  },
  "counts": {
    "open": "مفتوحة",
    "unassigned": "غير مسندة",
    "overdue": "متأخرة",
    "blocked": "معطلة",
    "inReview": "قيد المراجعة"
  },
  "list": {
    "title": "الفرق",
    "intro": "من يتولى أي عمل. يمكن أن يضم الفريق أشخاصًا من أقسام مختلفة.",
    "views": "عروض الفرق",
    "view": {
      "active": "النشطة",
      "mine": "فرقي",
      "archived": "المؤرشفة"
    },
    "searchPlaceholder": "ابحث في الفرق",
    "searchLabel": "البحث في الفرق",
    "tableLabel": "الفرق",
    "empty": {
      "filteredTitle": "لا يوجد فريق يطابق هذا البحث",
      "title": "لا توجد فرق بعد",
      "body": "أنشئ فريقًا وأضف أعضاءه واختر قادته، فتنتظر أعمال الفريق في قائمة الفريق.",
      "view": {
        "active": "لا توجد فرق نشطة.",
        "mine": "لست عضوًا في أي فريق.",
        "archived": "لا توجد فرق مؤرشفة."
      }
    },
    "clearSearch": "مسح البحث",
    "card": {
      "yourRole": "دورك:",
      "noLeads": "لا قائد بعد",
      "noMembers": "لا أعضاء بعد",
      "membersLabel": "الأعضاء: {{names}}"
    }
  },
  "form": {
    "newTitle": "فريق جديد",
    "newBody": "يتولى الفريق العمل، ويراجعه قادته ويوزعونه.",
    "editTitle": "تعديل الفريق",
    "descriptionPlaceholder": "ما الذي يتولاه الفريق",
    "hints": {
      "allowSelfClaim": "وإلا فقادة الفريق وحدهم يوزعون الأعمال المنتظرة.",
      "fieldService": "فرق الخدمة الميدانية هي التي تُعرض عند حجز الزيارات وتظهر في لوحة الخدمة.",
      "members": "ابحث عن الأشخاص بالاسم أو البريد الإلكتروني. يمكن أن يكون للفريق أكثر من قائد."
    },
    "addMember": "أضف شخصًا",
    "roleOf": "دور {{name}}",
    "removeMember": "إزالة {{name}}",
    "noMembers": "لا أعضاء بعد. أول شخص تضيفه يصبح قائدًا.",
    "create": "إنشاء الفريق",
    "errors": {
      "name": "أدخل اسمًا للفريق.",
      "nameTaken": "يوجد فريق آخر بهذا الاسم."
    }
  },
  "toast": {
    "created": "أُنشئ فريق {{name}}",
    "saved": "حُفظ فريق {{name}}",
    "archived": "أُرشف فريق {{name}}",
    "restored": "استُعيد فريق {{name}}"
  },
  "archive": {
    "title": "أرشفة {{name}}؟",
    "body": "لن يتلقى الفريق مهام أو زيارات جديدة وسيختفي من قوائم اختيار الفرق. تبقى أعماله السابقة مرتبطة به، ويمكنك استعادته لاحقًا.",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يمكن للفريق تلقي المهام والزيارات مجددًا.",
    "confirm": "أرشفة الفريق",
    "restoreConfirm": "استعادة الفريق",
    "hasOpenTasks_zero": "ما زالت لدى هذا الفريق مهام مفتوحة. انقلها إلى فريق آخر أو أنجزها قبل أرشفته.",
    "hasOpenTasks_one": "ما زالت لدى هذا الفريق مهمة مفتوحة واحدة. انقلها إلى فريق آخر أو أنجزها قبل أرشفته.",
    "hasOpenTasks_two": "ما زالت لدى هذا الفريق مهمتان مفتوحتان. انقلهما إلى فريق آخر أو أنجزهما قبل أرشفته.",
    "hasOpenTasks_few": "ما زالت لدى هذا الفريق {{n}} مهام مفتوحة. انقلها إلى فريق آخر أو أنجزها قبل أرشفته.",
    "hasOpenTasks_many": "ما زالت لدى هذا الفريق {{n}} مهمة مفتوحة. انقلها إلى فريق آخر أو أنجزها قبل أرشفته.",
    "hasOpenTasks_other": "ما زالت لدى هذا الفريق {{n}} مهمة مفتوحة. انقلها إلى فريق آخر أو أنجزها قبل أرشفته.",
    "showOpenTasks": "عرض مهامه المفتوحة"
  },
  "workspace": {
    "memberCount_zero": "لا أعضاء",
    "memberCount_one": "عضو واحد",
    "memberCount_two": "عضوان",
    "memberCount_few": "{{n}} أعضاء",
    "memberCount_many": "{{n}} عضوًا",
    "memberCount_other": "{{n}} عضو",
    "myRole": {
      "LEAD": "أنت قائد هذا الفريق",
      "MEMBER": "أنت عضو في الفريق",
      "none": "لست عضوًا في الفريق"
    },
    "selfClaim": "يأخذ الأعضاء الأعمال من قائمة الفريق",
    "leadsAssign": "يوزع القادة الأعمال المنتظرة",
    "archivedBanner": "أُرشف في {{date}}. استعد الفريق ليتلقى أعمالًا جديدة.",
    "attention": "يحتاج إلى متابعة",
    "ofOpen": "من {{n}} مفتوحة"
  },
  "queue": {
    "title": "قائمة الفريق",
    "hint": "أعمال غير مسندة، الأقدم أولًا. خذ مهمة لتصبح مسؤولًا عنها.",
    "hintNoTake": "أعمال غير مسندة، الأقدم أولًا.",
    "empty": "قائمة الفريق فارغة.",
    "take": "خذ المهمة",
    "takeLabel": "خذ المهمة {{number}}",
    "since": "في قائمة الفريق منذ {{date}}",
    "waitingDays_zero": "تنتظر منذ أقل من يوم",
    "waitingDays_one": "تنتظر منذ يوم واحد",
    "waitingDays_two": "تنتظر منذ يومين",
    "waitingDays_few": "تنتظر منذ {{n}} أيام",
    "waitingDays_many": "تنتظر منذ {{n}} يومًا",
    "waitingDays_other": "تنتظر منذ {{n}} يوم",
    "waitingHours_zero": "تنتظر منذ أقل من ساعة",
    "waitingHours_one": "تنتظر منذ ساعة واحدة",
    "waitingHours_two": "تنتظر منذ ساعتين",
    "waitingHours_few": "تنتظر منذ {{n}} ساعات",
    "waitingHours_many": "تنتظر منذ {{n}} ساعة",
    "waitingHours_other": "تنتظر منذ {{n}} ساعة",
    "waitingMinutes": "تنتظر منذ أقل من ساعة"
  },
  "showAll_zero": "عرض الكل في المهام",
  "showAll_one": "عرض المهمة في المهام",
  "showAll_two": "عرض المهمتين في المهام",
  "showAll_few": "عرض الـ{{n}} مهام في المهام",
  "showAll_many": "عرض الـ{{n}} مهمة في المهام",
  "showAll_other": "عرض الـ{{n}} مهمة في المهام",
  "showAllShort": "عرض الكل",
  "openWork": {
    "title": "أعمال الفريق المفتوحة",
    "empty": "لا شيء مفتوح. تظهر هنا الأعمال الجديدة لهذا الفريق."
  },
  "members": {
    "title": "الأعضاء",
    "empty": "لا أعضاء بعد. أضف أشخاصًا ليتمكن الفريق من تولي الأعمال.",
    "add": "إضافة أعضاء"
  },
  "errors": {
    "TEAM_HAS_OPEN_TASKS": "ما زالت لدى هذا الفريق مهام مفتوحة. انقلها إلى فريق آخر أو أنجزها قبل أرشفته.",
    "TEAM_HAS_OPEN_VISITS": "ما زالت لدى هذا الفريق زيارات خدمة مجدولة أو جارية. أعد جدولتها لفريق آخر أو أنجزها أو ألغها قبل أرشفته.",
    "TEAM_HAS_OPEN_TASKS_moduleOff": "ما زالت لدى هذا الفريق مهام مفتوحة، والمهام غير مفعّلة لشركتك، فلا يمكن نقلها أو إنجازها. أبقِ الفريق حتى تُفعَّل المهام من جديد.",
    "TEAM_HAS_OPEN_VISITS_moduleOff": "ما زالت لدى هذا الفريق زيارات خدمة مجدولة أو جارية، والخدمة غير مفعّلة لشركتك، فلا يمكن إعادة جدولتها أو إنجازها أو إلغاؤها. أبقِ الفريق حتى تُفعَّل الخدمة من جديد."
  }
}
